import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  moduloReset: {},
  wrap: {
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  leftPaper: {
    padding: theme.spacing(1),
    marginRight: theme.spacing(1),
    overflow: "hidden",
  },
  leftHeader: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  listItem: { cursor: "pointer" },
  actionsRow: { display: "flex", gap: theme.spacing(1) },
  optionRow: {
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  optionInput: { flex: 1 },
  sectionTitle: { marginTop: theme.spacing(2), marginBottom: theme.spacing(1) },
  editorPaper: {
    padding: theme.spacing(2),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  rightPanel: {
    padding: 16,
    backgroundColor: "#fafafa",
    borderRadius: 8,
  },
  rightPanelActions: {
    display: "flex",
    justifyContent: "flex-start",
    gap: 8,
  },

}));

export default useStyles;
